import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart, Sparkles, Cloud } from 'lucide-react';
export function FloatingDecorations() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-113">
      <motion.div className="absolute top-20 left-[10%] text-pastel-yellow/60" animate={{
      y: [0, -20, 0],
      rotate: [0, 10, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-114">
        <Star size={32} fill="currentColor" data-id="element-115" />
      </motion.div>

      <motion.div className="absolute top-40 right-[15%] text-pastel-pink/60" animate={{
      y: [0, -30, 0],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} data-id="element-116">
        <Heart size={40} fill="currentColor" data-id="element-117" />
      </motion.div>

      <motion.div className="absolute bottom-32 left-[20%] text-pastel-aqua/60" animate={{
      y: [0, -15, 0],
      rotate: [0, -15, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-118">
        <Cloud size={48} fill="currentColor" data-id="element-119" />
      </motion.div>

      <motion.div className="absolute bottom-40 right-[10%] text-pastel-lavender-dark/50" animate={{
      y: [0, -25, 0],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 4.5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.5
    }} data-id="element-120">
        <Sparkles size={36} data-id="element-121" />
      </motion.div>

      <motion.div className="absolute top-1/2 left-[5%] text-pastel-mint/60" animate={{
      y: [0, -20, 0],
      rotate: [0, 45, 0]
    }} transition={{
      duration: 5.5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1.5
    }} data-id="element-122">
        <Star size={24} fill="currentColor" data-id="element-123" />
      </motion.div>
    </div>;
}